import * as yup from "yup"

yup.setLocale({
  mixed: {
    required: "Dit veld is verplicht.",
  },

  string: {
    email: "Dit is een ongeldig e-mailadres.",
  },
})

export default yup
